<template>
  <div class="switch-block">
    <h3 class="switch-block__title">{{ $t('view.flow.block.switch.title') }}</h3>
    <in
      class="switch-block__condition-input"
      :label="$t('view.flow.block.switch.expression')"
      v-model="val.expression"
      @input="onInput"
    ></in>

    <div class="switch-block__cases">
      <div class="switch-block__case" v-for="(c, i) in val.cases" :key="i">
        <div class="switch-block__case-header">
          <h4>{{ $t('view.flow.block.switch.case') }}</h4>
          <in class="switch-block__case-input" v-model="c.case" @input="onInput"></in>
          <fai class="switch-block__case-delete" icon="times" @click="deleteCase(i)"></fai>
        </div>
        <div class="switch-block__dragzone">
          <steps-core
            ref="caseSteps"
            v-model="c.steps"
            :blockId="blockId"
            @singleStepMenu="$emit('singleStepMenu', $event)"
            @del="deleteCaseStep($event, i)"
          ></steps-core>
        </div>
      </div>
      <div class="switch-block__case">
        <div class="switch-block__case-header">
          <h4>{{ $t('view.flow.block.switch.default') }}</h4>
        </div>
        <div class="switch-block__dragzone">
          <steps-core
            ref="defaultSteps"
            v-model="val.defaultSteps"
            :blockId="blockId"
            @singleStepMenu="$emit('singleStepMenu', $event)"
            @del="deleteStep($event, 'defaultSteps')"
          ></steps-core>
        </div>
      </div>
    </div>

    <div class="switch-block__new-case" @click="addCase">{{ $t('view.flow.block.switch.addCase') }}</div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      val: null
    }
  },
  props: ['value', 'blockId'],
  created() {
    this.val = this.value
  },
  methods: {
    onInput() {
      this.$emit('input', this.val)
      this.$store.commit('SET_FLOW_EDIT_FLAG', [this.blockId, true])
      this.$store.commit('SET_EDITED', true)
    },

    addCase() {
      this.val.cases.push({
        case: '',
        steps: []
      })
      this.onInput()
    },

    deleteCase(i) {
      this.val.cases.splice(i, 1)
      this.onInput()
    },

    deleteStep(id, arrName) {
      for (let i = 0; i < this.val[arrName].length; i++) {
        if (this.val[arrName][i].uuid === id) {
          this.$delete(this.val[arrName], i)
          this.onInput()
          break
        }
      }
    },

    deleteCaseStep(id, c) {
      for (let i = 0; i < this.val.cases[c].steps.length; i++) {
        if (this.val.cases[c].steps[i].uuid === id) {
          this.$delete(this.val.cases[c].steps, i)
          this.onInput()
          break
        }
      }
    },

    async beforeSave() {
      await this.runHooks('beforeSave')
    },

    async runHooks(hookName) {
      await this.$refs.defaultSteps.runHooks(hookName)
      for (const component of this.$refs.caseSteps) {
        await component.runHooks(hookName)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.switch-block {
  @include flowElementShadow;
  width: 90%;
  background-color: white;
  border-radius: 7px;
  padding: 1px 10px 10px 14px;

  &__condition-input {
    width: 25%;
    min-width: 200px;
  }

  &__dragzone {
    background-color: #f1f1f1;
    border-radius: 4px;
    padding: 3px 10px 5px 10px;
    min-height: 70px;
  }

  &__new-case {
    @include clickableText();
    text-align: center;
    color: $danger;
    text-transform: uppercase;
    margin-top: 10px;
  }

  &__case-header {
    @include alignedFlex;
    justify-content: flex-start;

    & > h4 {
      margin-right: 12px;
    }
  }

  &__case-delete {
    margin-left: 10px;
    margin-top: 4px;
    cursor: pointer;
    color: $danger;
  }
}
</style>
